import { Tab } from "@mui/material"
import { TabPanel } from "@mui/lab"
import { withSecure } from "lib/authorization/secure"

export const SecureTabPanel = withSecure(TabPanel)
export const SecureTab = withSecure(Tab)
